import React, { useState, useEffect } from "react";
import ReactFileReader from 'react-file-reader';
// I18n
import CancelIcon from "@material-ui/icons/Cancel";
import { useTranslation } from "react-i18next";

import { CSVLink } from 'react-csv';
import {
  Card,
  CardContent,
  Grid,
  Paper,
  Button,
  IconButton,
} from "./index";

import "date-fns";
import Styles from "./styles";
import { Typography, 
  Select, 
  CircularProgress,  
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions, } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { uploadITContractorFiles, getITContractorWorkerByEmail } from "services";
import { MANAGE_WORKERS } from "../../navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import { SET_EMPTY, MB,ITContractorExportHeader,ITContractorFileHeader,ITContractorTemplate } from "../../config";
import SectionHead from "../../components/SectionHead";

import { isEmptyObject } from "utils";
const errorMessageObject = {
  project: SET_EMPTY,
  fileList : SET_EMPTY
};
const KEY = "itContractorForm";

  const ITContractorUploadView = (props) => {
  const history = useHistory();
  const [exportData, setExportData] = useState([]);
  const [exportTemplate, setExportTemplate] = useState([]);
  const [fileList, setFileList] = useState([]);
  const classes = Styles();
  const { t, i18n } = useTranslation();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isSaveEnable, setIsSaveEnable] = useState(true);
  const [project, setProject] = useState("");
  const [errorMessage, setErrorMessage] = useState(errorMessageObject);
  const [errrorFileFormat, setErrrorFileFormat] = useState('');
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const [successMessage, setsuccessMessage] = useState(SET_EMPTY);
  const [loading, setLoading] = useState(false);
  const [duplicateEmailList, setDuplicateEmailList] = useState([]);
  const [duplicateEmailEnable, setDuplicateEmailEnable] = useState(false);
  
  const { user, isAuthenticated } = useSelector((state) => state.user.auth);
  useEffect(() => {
    if (  (isEmptyObject(fileList))) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [fileList]);

  useEffect(() => {
   // setLoading(true);
   let dataToExport = [];
   dataToExport.push(ITContractorTemplate);
    
    setExportData(dataToExport);
    setsuccessMessage(SET_EMPTY);
    if (user && user.country) {
      console.log("userData",user);
     }
  }, [user]);
 
  const checkErrors = () => {
    const errorMessages = {
      project: SET_EMPTY,
      fileList : SET_EMPTY
    };
    const REQUIRED = "Required";

    
    if (isEmptyObject(fileList)) {
      errorMessages.fileList = REQUIRED;
      setErrrorFileFormat (REQUIRED);
    } else {
      errorMessages.fileList = SET_EMPTY;
      setErrrorFileFormat (SET_EMPTY);
    }
    setErrorMessage(errorMessages);
  };
  const backHandler = () => {
    // history.push(REVIEW, { isManageActivityGroup: true });
    history.push(MANAGE_WORKERS, { isManageActivityGroup: true });
  };
  const onSubmit = async () => {
    checkErrors();
    setIsSaveEnable(true);
   if (!isSubmitDisabled) {
    setLoading(true);
    try {
          console.log("fileList",fileList)
          let filePath = await uploadITContractorFiles(fileList);
          console.log("File paths for the uploaded files are  ", filePath);
        
        if(filePath != '')
        {
          onClear () ;
          setsuccessMessage(true);
          setIsSaveEnable(false);
        }else
        {
          console.log("file not uploaded");
        }
          // handleProcessingClose();
        } catch (error) {
            console.log(`
          data error
          error is ${error}
        `);
        setLoading(false);
        setIsSaveEnable(false);
          }
        } else {
          setIsSaveEnable(false);
          setErrorAlertDiag(true);
        }
   };

   const hasDuplicatesEmail = (arr) => arr.length !== new Set(arr).size;
  const  handleFiles = (files) => {
      try {
        
        setsuccessMessage(SET_EMPTY);
        const fileArray = [];
        const periodIndex = files[0].name.lastIndexOf(".");
        const extention = files[0].name.slice(periodIndex);
        const fileSize= files[0].size;
        console.log('fileSize',fileSize)
        //console.log("files",files) ;
        if(fileSize < MB){
          if(extention == '.csv')
          {
            setLoading(true);
            fileArray.push(files[0]);
            setFileList((fileArray));
            setErrrorFileFormat (SET_EMPTY);
            var reader = new FileReader();
            reader.onload = function(e) {
            var csv = reader.result;
            var lines = csv.split("\n");
            var result = [];
            var headers=lines[0].split(",");
            var isValidData = []; 
            let EmailData=[];
            let isMandatoryData = false;
            for(var i=1;i<lines.length;i++){
              console.log("row count",lines.length);
                var obj = {};
                var currentline=lines[i].split(",");
                for(var j=0;j<headers.length;j++){
                     const currentLine = currentline[j] ? currentline[j].replace(/['"]+/g, '').trim() : '';
                      console.log("currentline",currentLine);
                      obj[headers[j]] = currentLine;
                      const headerJ = headers[j] ? headers[j].replace(/['"]+/g, '').trim() : '';
                      console.log("dataheader",headers[j].replace(/['"]+/g, ''));
                      
                        if(!ITContractorFileHeader.includes(headerJ))
                        {
                          console.log("Headers not matched",headers);
                          isValidData.push(false);
                        }
                        else if((headerJ == 'First_Name' && currentLine =='') || 
                        (headerJ == 'Last_Name' && currentLine  =='' ) ||
                        (headerJ == 'Email_Work' && currentLine  =='' ) ||
                        (headerJ == 'Manager_ID' && currentLine  =='' ) ||
                        (headerJ == 'Is_Active_Worker' && currentLine  =='') ||
                        (headerJ == 'Agency' && currentLine  =='' ) ||
                        (headerJ == 'Job_Role' && currentLine  =='' ) ||
                        (headerJ == 'Country' && currentLine  =='') ||
                        (headerJ == 'Job_Type' && currentLine  =='' ) ||
                        (headerJ == 'Operational_District' && currentLine  =='') ||
                        (headerJ == 'Operational_Building' && currentLine  =='') ||
                        (headerJ == 'Bill_Rate' && currentLine  =='') ||
                        (headerJ == 'Currency' && currentLine  =='') 
                       )
                        {
                          isMandatoryData=true;
                        }
                        else if(headerJ === 'Email_Work')
                        {
                          EmailData.push(currentLine);
                         
                        }
                    }
                }
                 
              console.log("isMandatoryData",isMandatoryData);
              console.log("EmailData",EmailData);
              console.log("isValidData",isValidData);
              
              if(isMandatoryData)
              {
                let arr = [...fileList];
                arr.splice(0, 1);
                setFileList(arr);
                setErrrorFileFormat(t("other.lblIncorrectFileMandatoryData"));
                setLoading(false);
              }
             else if(hasDuplicatesEmail(EmailData))
              {
                let arr = [...fileList];
                arr.splice(0, 1);
                setFileList(arr);
                setErrrorFileFormat(t("other.lblIncorrectFileDuplicateEmailData"));
                setLoading(false);
              }
              else if(lines.length == 1  || isValidData.includes(false))
              {
                let arr = [...fileList];
                arr.splice(0, 1);
                setFileList(arr);
                setErrrorFileFormat(t("other.lblIncorrectFileData"));
                setLoading(false);
              }
              else{
                if(EmailData.length>0){
                  setLoading(true);
                  getITContractorWorkerByEmail(EmailData)
                  .then((doc) => {
                    console.log("emailList",  doc);
                    if (doc.length > 0) {
                      var dupEmail=[];
                      doc.forEach((record)=>{
                        dupEmail.push(record.email);
                      })
                      setDuplicateEmailList(dupEmail);
                      setDuplicateEmailEnable(true);
                      let arr = [...fileList];
                      arr.splice(0, 1);
                      setFileList(arr);
                      setErrrorFileFormat(t("other.lblIncorrectFileDuplicateData"));
                      setLoading(false);
                      setIsSaveEnable(true);
                    }else{
                      setIsSaveEnable(false);
                      setLoading(false);
                    }
                    
                    
                  })
                  .catch((err) => {
                    console.error("No response from getITContractorWorkerByEmail", err);
                    setLoading(false);
                  }); 
                }
               
                setErrrorFileFormat(SET_EMPTY);
              }
            
             
          }
          setLoading(false);
          reader.readAsText(files[0]);
          }
          else
          {
            hadleFileDelete(0)
            setLoading(false);
            setErrrorFileFormat(t("other.lblIncorrectFile"));
          }
        } else
        {
          hadleFileDelete(0)
          setLoading(false);
          setErrrorFileFormat( t("other.lblIncorrectFileMB"));
        }
        
      
  }
  catch(err){
    console.log("error Incorrect Data", err);
    setFileList([]);
    setErrrorFileFormat(t("other.lblIncorrectFileData"));
    setLoading(false);
  }
 }
  
  const fileNameDisplay = (fileName) => {
    if (fileName) {
      const periodIndex = fileName.lastIndexOf(".");
      const shortenedName = fileName.slice(0, periodIndex).slice(0, 40);
      const extention = fileName.slice(periodIndex);
      const fileNameNew = `${shortenedName}...${extention}`;
      return fileNameNew;
    }
  };
  const hadleFileDelete = (index) => {
    let arr = [...fileList];
    arr.splice(index, 1);
    setFileList(arr);
    setIsSaveEnable(true);
    
  };
 
  const onClear = () => {
    //setIsSubmitPressed(false);
    setProject(SET_EMPTY);
    setErrrorFileFormat (SET_EMPTY);
    hadleFileDelete(0);
    setIsSaveEnable(true);
    
  };
 
  const getExportData = async (event, done) =>{
    
    if(!isEmptyObject(exportData)) {
        done(true);
    }
  }
  return (
    <>
          <Grid container direction="row" justify="center">
            <Grid item sm={7} xs={12}>
              <Paper elevation={3} className={classes.card}>
                <SectionHead back={backHandler}  name= {t("other.lblITContratorFileUpload")}/>
           <Grid item>
              <Typography variant="body2" gutterBottom>
              {t("other.ParagraphcsvData")}
              </Typography>
              <Typography variant="body2" gutterBottom>
                {t("other.ParagraphmandatfieldITContractor")}
              </Typography>
            </Grid>
            
              <form className={classes.form} noValidate autoComplete="off">
                <Grid item xs={12} sm={12}>
                  <Card className={classes.root}>
                    <CardContent>
                     <Grid item>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          <CSVLink
                            data={exportData}
                            asyncOnClick={true}
                            onClick={getExportData}
                            headers={ITContractorExportHeader}
                            filename={`itcontractor_data.csv`} 
                            enclosingCharacter=''
                          >
                          <Button
                              type="Button"
                              variant="text"
                              color="primary"
                              style={{marginTop :10}}
                            
                            >
                             {t("other.lblTemplateITContrator")}
                            </Button>
                        </CSVLink>
                          
                        </Typography>
                      </Grid>
                     <Grid item>
                            <ReactFileReader handleFiles={handleFiles} fileTypes={'.csv'}>
                            <Button
                              className="btn-choose"
                              variant="outlined"
                              component="span"
                            >
                              {t("pgUploadCwk.chooseFile")}
                            </Button>
                            </ReactFileReader>
                           
                            <Grid item>   <span style={{ color: "red" }}>{errrorFileFormat}</span></Grid>
                            
                            
                          {fileList.map((file, index) => (
                            <Grid
                              container
                              direction="row"
                              justify="flex-start"
                              alignItems="center"
                            >
                              <Grid item>{fileNameDisplay(file.name)}</Grid>
                              <Grid item>
                                <IconButton
                                  variant="contained"
                                  color="primary"
                                  onClick={(event) => {
                                    hadleFileDelete(index);
                                  }}
                                >
                                  <CancelIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          ))}
                        
                      </Grid>
                      <Grid item>   <span style={{ color: "red" }}>{successMessage}</span></Grid>
                      <Grid
                        container
                        direction="row"
                        justify="space-between"
                        spacing={4}
                      >
                        <Grid item>
                          <Button
                            type="Button"
                            variant="text"
                            color="secondary"
                            style={{paddingTop:"10px"}}
                            onClick={onClear}
                          >
                            {t("other.lblClearForm")}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={onSubmit}
                            disabled={isSaveEnable }
                          >
                            {t("pgHome.btEmpId")}
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </form>
            
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
          {t("other.lblPleaseFillAllFields")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={successMessage}
        onClose={() => {
          setsuccessMessage(false);
        }}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="success-dialog-title"> {t("other.lblSuccess")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
          {t("other.lblSuccessFileUpload")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setsuccessMessage(false);
                    setLoading(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={loading}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="dialog-title">{t("other.tlProcessing")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container justify="center">
              <Grid item>
                <CircularProgress className={classes.center} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={duplicateEmailEnable}
        onClose={() => {
          setDuplicateEmailEnable(false);
          setDuplicateEmailList([]);
        }}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="success-dialog-title"> Duplicate Record Found</DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
          <Grid container justify="left">
              {duplicateEmailList.map(emailItem => 
              <Grid item  alignItems="left" justify="flex-start">{emailItem}</Grid>)}
            </Grid>
            
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setDuplicateEmailEnable(false);
                    setDuplicateEmailList([]);
                    
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

ITContractorUploadView.propTypes = {};

export default ITContractorUploadView;
